import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import Link from '@material-ui/core/Link';
import { FEATURE } from '../../routing';
import AirPlaneImage from '../../../../images/features/ana/airplane.png';
import CollaborationImage from '../../../../images/features/ana/collaboration_logo.png';

const useAlertStyles = makeStyles((theme) => ({
  root: {},
  alert: {
    maxWidth: theme.breakpoints.values.md,
    position: 'relative',
    lineHeight: 1.8,
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  collaborationContainer: {
    textAlign: 'center',
    marginBottom: theme.spacing(3),
    '& img': {
      width: '100%',
      maxWidth: 300,
      height: 'auto',
      [theme.breakpoints.up('sm')]: {
        maxWidth: 400,
      },
    },
  },
  airplane: {
    position: 'absolute',
    bottom: -30,
    right: 5,
    width: 100,
    zIndex: 5,
    height: 'auto',
  },
  text: {
    position: 'relative',
    zIndex: 10,
  },
}));

export const AnaAlert = ({
  onClick,
  classes: overridableClasses,
  AlertProps = {},
}) => {
  const classes = useAlertStyles({ classes: overridableClasses });

  return (
    <div className={classes.root}>
      <div className={classes.collaborationContainer}>
        <img src={CollaborationImage} />
      </div>
      <Alert
        icon={false}
        severity="info"
        className={classes.alert}
        {...AlertProps}
      >
        <img src={AirPlaneImage} className={classes.airplane} />
        <span className={classes.text}>
          この募集はANAトラベラーズとのコラボとなっています。日程に合わせたANAトラベラーズの航空券と宿泊を購入して、おてつたび先の地域に訪れることができます。
          詳しくは
          <Link
            href={FEATURE.replace(':path', 'ana')}
            target="_blank"
            underline="always"
            onClick={onClick}
          >
            こちらを
          </Link>
          ご覧ください
        </span>
      </Alert>
    </div>
  );
};
